import '@babel/polyfill'
import 'ie-array-find-polyfill'

import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import registerServiceWorker from './registerServiceWorker'

import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import reducer from './reducers'
import fetchPages from './fetchAPI/fetchPages'
import fetchCalendar from './fetchAPI/fetchCalendar'
import submitContactForm from './fetchAPI/submitContactForm'

const store = createStore(reducer, composeWithDevTools(
	applyMiddleware(thunk.withExtraArgument({
		fetchPages,
		fetchCalendar,
		submitContactForm,
	}))
))

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js